import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'

/**
 * Block Meter Details data
 * @param {string} stationCode
 * @param {number} blockIndex
 * @param {number} blockMeterIndex
 * @returns UseQueryResult
 */
const useBlockMeterDetailsQuery = () => {
  const { stationCode, blockIndex, blockMeterIndex } = useParams()
  const { session } = useContext(SessionContext)

  return useQuery(
    ['blockMeterDetails', stationCode, blockIndex, blockMeterIndex],
    async () => {
      const apiUrl = session.server
      const axiosOptions = {
        headers: {
          Accept: 'application/json',
          papitoken: session.token,
        },
      }

      const response = await axios.get(
        `${apiUrl}station/${stationCode}/block/${blockIndex}/blockmeters/${blockMeterIndex}/status`,
        axiosOptions,
      )
      return response.data
    },
    { refetchInterval: 5000 },
  )
}

export default useBlockMeterDetailsQuery
